import React, { useEffect, useState } from "react";

import CompanyAPI from "../pages/company/CompanyAPI";
import HallAppToast from "../commons/HallAppToast";
import Splash from "../commons/pages/splash/Splash";
import { useNavigate } from "react-router-dom";

const LOCAL_STORAGE_KEY = "hallapp-menu-config";

function getDefaultRoute() {
  let defaultPath = "inicio";

  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed?.defaultPath) defaultPath = parsed.defaultPath;
    }
  } catch (e) {
    console.warn("Erro ao ler defaultPath do menu (sso)", e);
  }

  return `/${defaultPath}`;
}

function sanitizeInternalRoute(route) {
  if (!route) return null;

  let r = String(route).trim();

  r = r.replace(/[#?].*$/, "");

  r = r.replace(/^\/+/, "");

  if (!r) return null;
  if (r.includes("://")) return null; // http://
  if (r.startsWith("//")) return null; // protocolo relativo
  if (r.includes("\\")) return null; // barra invertida
  if (r.includes("..")) return null; // path traversal

  return `/${r}`;
}

function getQueryParams() {
  if (window.location.search && window.location.search.includes("token=")) {
    return new URLSearchParams(window.location.search);
  }

  const hash = window.location.hash || ""; 
  const idx = hash.indexOf("?");
  if (idx >= 0) {
    return new URLSearchParams(hash.slice(idx + 1));
  }

  return new URLSearchParams();
}

export default function SsoRedirect() {
  const [showSplash, setShowSplash] = useState(true);
  const navigate = useNavigate();
  const companyAPI = new CompanyAPI();

  useEffect(() => {
    const run = async () => {
      const qs = getQueryParams();
      const token = qs.get("token");
      const routeParam = qs.get("route"); 

      if (!token) {
        HallAppToast.error("Token não informado.");
        window.location.replace(`${window.location.origin}${window.location.pathname}#/login`);
        return;
      }

      localStorage.setItem("hallapp-runtime", "flutter");

      localStorage.setItem("token", token);

      const base = `${window.location.origin}${window.location.pathname}`;
      window.history.replaceState({}, document.title, `${base}#/sso`);

      try {
        const response = await companyAPI.findAllMe();

        if (response?.data?.length > 0) {
          const data = response.data[0];
          companyAPI.setCompanyManagment(data);
          companyAPI.setCompaniesLocalStorage(response.data);
        }

        const safeRoute = sanitizeInternalRoute(routeParam);
        const target = safeRoute || getDefaultRoute();

        navigate(target, { replace: true });
      } catch (e) {
        console.error("Erro no SSO bootstrap", e);

        localStorage.removeItem("token");
        localStorage.removeItem("company-management");
        localStorage.removeItem("companies");
        localStorage.removeItem("hallapp-runtime");

        HallAppToast.error("Sessão inválida. Faça login novamente.");
        navigate("/login", { replace: true });
      } finally {
        setShowSplash(false);
      }
    };

    run();
  }, [navigate]);

  return showSplash ? <Splash /> : null;
}
